import { httpAdminReport } from "../helper/http-common";
class ReportsGemstoneService {
  GemstoneChartForCutGrade(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GemstoneChartForCutGrade",
      inputData
    );
  }
  LoadExtendedGemstoneChartReports(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/LoadExtendedGemstoneChartReports",
      inputData
    );
  }
  CheckDealermembers(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/CheckDealermembers",
      inputData
    );
  }
  GetGemstoneColumnChartData(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GetGemstoneColumnChartData",
      inputData
    );
  }
  GetGemstoneReportForTableChart(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GetGemstoneReportForTableChart",
      inputData
    );
  }
  GetGemstoneReportForTableChartAll(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GetGemstoneReportForTableChartAll",
      inputData
    );
  }
  GemstoneChart_SortingBindData(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GemstoneChart_SortingBindData",
      inputData
    );
  }
  ExportToPDF(inputData) {
    return httpAdminReport.post("/GemstoneReport/ExportToPDF", inputData, {
      responseType: "arraybuffer",
    });
  }
  ExportToCSV(inputData) {
    return httpAdminReport.post("/GemstoneReport/ExportToCSV", inputData, {
      responseType: "arraybuffer",
    });
  }

  ExportDataToCSV(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GetGemstoneReportForTableChartAll_CSV_Download",
      inputData
    );
  }

  ExportDataToPDF(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GetGemstoneReportForTableChartAll_PDF_Download",
      inputData,
      { responseType: "arraybuffer" }
    );
  }

  ExportTableDataToPDF(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/GetGemstoneReportForTableChart_PDF",
      inputData,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  AddToCartOrWishlistReportForTableChart(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/AddToCartOrWishlistReportForTableChart",
      inputData
    );
  }
  AddToCartOrWishlistChartColunmData(inputData) {
    return httpAdminReport.post(
      "/GemstoneReport/AddToCartOrWishlistChartColunmData",
      inputData
    );
  }
}

export default new ReportsGemstoneService();
